import "./Finances.style.css";

// React
import { useEffect, useState } from "react";

// React Router Dom
import { useNavigate } from "react-router-dom";

// Axios
import axios from "axios";

// Components
import NavigationBar from "../../../Components/NavigationBar";
import SideBar from "../../../Components/SideBar";

// Function
import formatRupiah from "../../../Function/formatRupiah";

// React Bootstrap
import { Button, InputGroup, Form, Table, Modal, Spinner, Placeholder } from "react-bootstrap";

// React Bootstrap Icons
import { Search, PlusLg } from "react-bootstrap-icons";

// Sweet Alert 2
import Swal from "sweetalert2";

const PageFinancesBusiness = () => {
    const navigate = useNavigate();

    const [isPageLoading, setIsPageLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [alertMessage, setAlertMessage] = useState({});

    const [accessToken] = useState(localStorage.getItem("accessToken"));
    // const [userData] = useState(JSON.parse(localStorage.getItem("userData")));

    const [financeData, setFinanceData] = useState([]);
    const [financeSearch, setFinanceSearch] = useState(new Date().toISOString().slice(0, 10));

    const [financeStoreShow, setFinanceStoreShow] = useState(false);
    const [financeUpdateShow, setFinanceUpdateShow] = useState({ status: false, data: null });

    const [financeDate, setFinanceDate] = useState(new Date().toISOString().slice(0, 10));
    const [financeType, setFinanceType] = useState(null);
    const [financeAmount, setFinanceAmount] = useState(null);
    const [financeCategory, setFinanceCategory] = useState(null);
    const [financeDescription, setFinanceDescription] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            if (!accessToken) return navigate("/");

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            axios.defaults.headers.common['Accept'] = `application/json`;
            await axios.get(`${process.env.REACT_APP_API_URL}/api/user`).then(() => {}).catch(() => navigate("/"));

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            axios.defaults.headers.common['Accept'] = `application/json`;
            await axios.get(`${process.env.REACT_APP_API_URL}/api/finance/show?type=business&search=${new Date().toISOString().slice(0, 10)}`).then((res) => {
                setFinanceData(res.data.data);
            }).catch((err) => {
                if (err.status === 404) setFinanceData(err.response.data);
                else setFinanceData({"message": "Internal Server Error"});
            })

            await setTimeout(() => setIsPageLoading(false), 500);
            return 1;
        }

        fetchData();
    }, [navigate, accessToken]);

    const handleSearchFinances = async () => {
        if (isLoading) return 1;
        
        setFinanceDate(financeSearch);
        setIsLoading(true);

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.get(`${process.env.REACT_APP_API_URL}/api/finance/show?type=business&search=${financeSearch}`).then((res) => {
            setFinanceData(res.data.data);
        }).catch((err) => {
            if (err.status === 404) setFinanceData(err.response.data);
            else setFinanceData({"message": "Internal Server Error"});
        })

        await setIsLoading(false);
        return 1;
    }

    const handleFinanceStore = async (e) => {
        e.preventDefault();

        if (isLoading) return 1;

        const errors = {};

        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

        if (financeDate === "" || financeDate?.length === 0 || financeDate === null || financeDate === undefined) {
            errors.date = "Finance date is required!";
        } else if (!dateRegex.test(financeDate)) {
            errors.date = "Date format must be YYYY-MM-DD!";
        }

        if (financeType === "" || financeType?.length === 0 || financeType === null || financeType === undefined) {
            errors.type = "Finance type is required!";
        } else if (financeType !== "income" && financeType !== "expense") {
            errors.type = "Finance type must be income or expense!";
        }

        if (financeAmount === "" || financeAmount?.length === 0 || financeAmount === null || financeAmount === undefined) {
            errors.amount = "Finance amount is required!";
        } else if (financeAmount < 0) {
            errors.amount = "Finance amount must be greater than 0!";
        }

        if (financeCategory === "" || financeCategory?.length === 0 || financeCategory === null || financeCategory === undefined) {
            errors.category = "Finance category is required!";
        } else if (financeCategory !== "business" && financeCategory !== "personal" && financeCategory !== "debt") {
            errors.category = "Finance category must be business, personal or debt!";
        }

        if (financeDescription === "" || financeDescription?.length === 0 || financeDescription === null || financeDescription === undefined) {
            errors.description = "Finance description is required!";
        } else if (financeDescription?.length > 255) {
            errors.description = "Finance description must be less than 255 characters!";
        }

        if (Object.keys(errors).length > 0) {
            return setAlertMessage(errors);
        }

        setAlertMessage({});
        setIsLoading(true);

        const formData = new FormData();
        formData.append("date", financeDate);
        formData.append("type", financeType);
        formData.append("amount", financeAmount);
        formData.append("category", financeCategory);
        formData.append("description", financeDescription);

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.post(`${process.env.REACT_APP_API_URL}/api/finance/store`, formData).then((res) => {
            setIsLoading(false);

            setFinanceStoreShow(false);
            handleSearchFinances();

            setFinanceDate(new Date().toISOString().slice(0, 10));
            setFinanceType(null);
            setFinanceAmount(null);
            setFinanceCategory(null);
            setFinanceDescription(null);

            return Swal.fire({
                title: "Success!",
                text: res.data.message,
                icon: "success"
            });
        }).catch((err) => {
            setIsLoading(false);
            
            if (err?.response?.status === 422) {
                return setAlertMessage(err?.response?.data?.errors);
            } else {
                console.error(err);
                setFinanceStoreShow(false);

                return Swal.fire({
                    title: "Oops!",
                    text: "Internal server error",
                    icon: "error"
                });
            }
        })
        return 1;
    }

    const handleFinanceUpdate = async (e) => {
        e.preventDefault();

        if (isLoading) return 1;

        const errors = {};

        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

        if (financeDate && (!dateRegex.test(financeDate))) {
            errors.date = "Date format must be YYYY-MM-DD!";
        }

        if (financeType && (financeType !== "income" && financeType !== "expense")) {
            errors.type = "Finance type must be income or expense!";
        }

        if (financeAmount && (financeAmount < 0)) {
            errors.amount = "Finance amount must be greater than 0!";
        }

        if (financeCategory && (financeCategory !== "business" && financeCategory !== "personal" && financeCategory !== "debt")) {
            errors.category = "Finance category must be business, personal or debt!";
        }

        if (financeDescription && (financeDescription?.length > 255)) {
            errors.description = "Finance description must be less than 255 characters!";
        }

        if (Object.keys(errors).length > 0) {
            return setAlertMessage(errors);
        }

        setAlertMessage({});
        setIsLoading(true);

        const formData = new FormData();
        if (financeDate) formData.append("date", financeDate);
        if (financeType) formData.append("type", financeType);
        if (financeAmount) formData.append("amount", financeAmount);
        if (financeCategory) formData.append("category", financeCategory);
        if (financeDescription) formData.append("description", financeDescription);

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.post(`${process.env.REACT_APP_API_URL}/api/finance/update/${financeUpdateShow.data.id}`, formData).then((res) => {
            setIsLoading(false);

            setFinanceUpdateShow({ status: false, data: null });
            handleSearchFinances();

            setFinanceDate(new Date().toISOString().slice(0, 10));
            setFinanceType(null);
            setFinanceAmount(null);
            setFinanceCategory(null);
            setFinanceDescription(null);

            return Swal.fire({
                title: "Success!",
                text: res.data.message,
                icon: "success"
            });
        }).catch((err) => {
            setIsLoading(false);
            
            if (err?.response?.status === 422) {
                return setAlertMessage(err?.response?.data?.errors);
            } else {
                console.error(err);
                setFinanceUpdateShow({ status: false, data: null });

                return Swal.fire({
                    title: "Oops!",
                    text: "Internal server error",
                    icon: "error"
                });
            }
        })
        return 1;
    }

    const handleFinanceDelete = async (finance_id) => {
        if (isLoading) return 1;

        setFinanceUpdateShow({ status: false, data: financeUpdateShow.data });

        Swal.fire({
            title: "Delete Finance",
            text: `Are you sure you want to delete Fincance (ID: ${finance_id})?`,
            icon: "question",
            showCancelButton: true
        }).then(async (r) => {
            if (r.isConfirmed) {
                setIsLoading(true);

                axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
                axios.defaults.headers.common['Accept'] = `application/json`;
                await axios.delete(`${process.env.REACT_APP_API_URL}/api/finance/destroy/${finance_id}`).then((res) => {
                    setIsLoading(false);
                    handleSearchFinances();
                    
                    return Swal.fire({
                        title: "Success!",
                        text: res.data.message,
                        icon: "success"
                    });
                }).catch((err) => {
                    setIsLoading(false);

                    if (err?.response?.status === 404) {
                        return Swal.fire({
                            title: "Oops!",
                            text: err?.response?.data?.message,
                            icon: "error"
                        });
                    } else {
                        console.error(err);

                        return Swal.fire({
                            title: "Oops!",
                            text: "Internal server error",
                            icon: "error"
                        });
                    }
                })
            } else {
                setFinanceUpdateShow({ status: true, data: financeUpdateShow.data });
            }
        });
    }

    return (
        <section id="finances" className="finances">
            {/* Navigation Bar */}
            <NavigationBar />

            <div className="content-wrapper">
                {/* Side Bar */}
                <SideBar />

                <div className="contents">
                    {!isPageLoading ? (
                        <>
                            <header>
                                <h4>Finances</h4>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <InputGroup>
                                        <Form.Control type="date" disabled={isLoading} placeholder="Search Orders" value={financeSearch} onChange={(e) => setFinanceSearch(e.target.value)} />
                                        <Button variant="primary" disabled={isLoading} onClick={handleSearchFinances}><Search /></Button>
                                    </InputGroup>
                                    <Button variant="success" onClick={() => setFinanceStoreShow(true)}><PlusLg /></Button>
                                </div>
                            </header>
                            <main>
                                {financeData?.message && <h6>{financeData.message}</h6>}

                                {financeData && (
                                    <Table striped bordered>
                                        <thead>
                                            <tr>
                                                <th>Income</th>
                                                <th>Expense (Business)</th>
                                                {/* <th>Expense (Personal)</th> */}
                                                {/* <th>Expense (Debt)</th> */}
                                                <th>Balance</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="fw-bold text-primary">{formatRupiah(financeData.total_income + financeData.total_order_income)}</td>
                                                <td className="fw-bold text-danger">{formatRupiah(financeData.total_expense_business)}</td>
                                                {/* <td className="fw-bold text-danger">{formatRupiah(financeData.total_expense_personal)}</td> */}
                                                {/* <td className="fw-bold text-danger">{formatRupiah(financeData.total_expense_debt)}</td> */}
                                                <td className="fw-bold text-success">{formatRupiah(financeData.total_income + financeData.total_order_income - financeData.total_expense_business)}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                )}

                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Category</th>
                                            <th>Description</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {financeData?.data?.map((item, index) => (
                                            <tr key={index} onClick={() => item.id > 0 && setFinanceUpdateShow({ status: true, data: item })}>
                                                <td style={{ textTransform: "capitalize" }}>{item.category}</td>
                                                <td>{item.description}</td>
                                                <td className={`${item.type === "expense" ? "text-danger" : "text-primary"} fw-semibold`}>{formatRupiah(item.amount)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </main>
                        </>
                    ) : (
                        <>
                            <header>
                                <Placeholder animation="glow">
                                    <Placeholder style={{ borderRadius: "8px",  width: "100px", height: "24px" }} />
                                </Placeholder>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <Placeholder animation="glow">
                                        <Placeholder style={{ borderRadius: "8px",  width: "250px", height: "32px" }} />
                                    </Placeholder>
                                    <Placeholder animation="glow">
                                        <Placeholder style={{ borderRadius: "8px",  width: "32px", height: "32px" }} />
                                    </Placeholder>
                                </div>
                            </header>
                            <main>
                                <Table striped bordered>
                                    <thead>
                                        <tr>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "100px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "150px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "100px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "150px", height: "16px" }} />
                                                </Placeholder>
                                            </td>
                                            <td>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "150px", height: "16px" }} />
                                                </Placeholder>
                                            </td>
                                            <td>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "150px", height: "16px" }} />
                                                </Placeholder>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>

                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "100px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "125px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                            <th>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "100px", height: "16px" }} />
                                                </Placeholder>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.from({ length: 6 }).map((_, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px", width: "150px", height: "16px" }} />
                                                    </Placeholder>
                                                </td>
                                                <td>
                                                    <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px", width: "150px", height: "16px" }} />
                                                    </Placeholder>
                                                </td>
                                                <td>
                                                    <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px", width: "150px", height: "16px" }} />
                                                    </Placeholder>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </main>
                        </>
                    )}
                </div>
            </div>

            {/* Modal Finance Store */}
            <Modal show={financeStoreShow} onHide={() => setFinanceStoreShow(false)}>
                <form action="POST" onSubmit={handleFinanceStore}>
                    <Modal.Header closeButton>
                        <Modal.Title>Finance Store</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Date <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="date" placeholder="Enter finance date" value={financeDate} disabled />
                            {alertMessage?.date && <Form.Text className="text-danger">{alertMessage.date}</Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Type <span className="text-danger">*</span></Form.Label>
                            <Form.Select value={financeType} onChange={(e) => setFinanceType(e.target.value)} disabled={isLoading}>
                                <option value="">-</option>
                                <option value="income">Income</option>
                                <option value="expense">Expense</option>
                            </Form.Select>
                            {alertMessage?.type && <Form.Text className="text-danger">{alertMessage.type}</Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Amount <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="number" placeholder="Enter finance amount" value={financeAmount} onChange={(e) => setFinanceAmount(e.target.value)} disabled={isLoading} />
                            {alertMessage?.amount && <Form.Text className="text-danger">{alertMessage.amount}</Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Category <span className="text-danger">*</span></Form.Label>
                            <Form.Select value={financeCategory} onChange={(e) => setFinanceCategory(e.target.value)} disabled={isLoading}>
                                <option value="">-</option>
                                <option value="business">Business</option>
                                <option value="personal">Personal</option>
                                <option value="debt">Debt</option>
                            </Form.Select>
                            {alertMessage?.category && <Form.Text className="text-danger">{alertMessage.category}</Form.Text>}
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Description <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="text" placeholder="Enter finance description" value={financeDescription} onChange={(e) => setFinanceDescription(e.target.value)} disabled={isLoading} />
                            {alertMessage?.description && <Form.Text className="text-danger">{alertMessage.description}</Form.Text>}
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" type="submit" disabled={isLoading}>
                            {isLoading && <Spinner size="sm" className="me-2" />}
                            Submit
                        </Button>
                        <Button variant="secondary" onClick={() => setFinanceStoreShow(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
            {/* End of Modal Finance Store */}

            {/* Modal Finance Update */}
            <Modal show={financeUpdateShow.status} onHide={() => setFinanceUpdateShow({ status: false, data: null })} centered>
                <form action="POST" onSubmit={handleFinanceUpdate}>
                    <Modal.Header closeButton>
                        <Modal.Title>Finance Update (ID: {financeUpdateShow?.data?.id})</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: "448px", overflowY: "auto" }}>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold">Date <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="date" placeholder="Enter finance date" defaultValue={financeUpdateShow?.data?.date} onChange={(e) => setFinanceDate(e.target.value)} />
                            {alertMessage?.date && <Form.Text className="text-danger">{alertMessage.date}</Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold">Type <span className="text-danger">*</span></Form.Label>
                            <Form.Select defaultValue={financeUpdateShow?.data?.type} onChange={(e) => setFinanceType(e.target.value)}>
                                <option value="">-</option>
                                <option value="income">Income</option>
                                <option value="expense">Expense</option>
                            </Form.Select>
                            {alertMessage?.type && <Form.Text className="text-danger">{alertMessage.type}</Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold">Amount <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="number" placeholder="Enter finance amount" defaultValue={financeUpdateShow?.data?.amount} onChange={(e) => setFinanceAmount(e.target.value)} />
                            {alertMessage?.amount && <Form.Text className="text-danger">{alertMessage.amount}</Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold">Category <span className="text-danger">*</span></Form.Label>
                            <Form.Select defaultValue={financeUpdateShow?.data?.category} onChange={(e) => setFinanceCategory(e.target.value)}>
                                <option value="">-</option>
                                <option value="business">Business</option>
                                <option value="personal">Personal</option>
                                <option value="debt">Debt</option>
                            </Form.Select>
                            {alertMessage?.category && <Form.Text className="text-danger">{alertMessage.category}</Form.Text>}
                        </Form.Group>

                        <Form.Group>
                            <Form.Label className="fw-semibold">Description <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="text" placeholder="Enter finance description" defaultValue={financeUpdateShow?.data?.description} onChange={(e) => setFinanceDescription(e.target.value)} />
                            {alertMessage?.description && <Form.Text className="text-danger">{alertMessage.description}</Form.Text>}
                        </Form.Group>

                        <p className="mt-3 mb-2 fw-semibold">Finance Menu</p>
                        <Button variant="danger" className="w-100" onClick={() => handleFinanceDelete(financeUpdateShow?.data?.id)} disabled={isLoading}>Delete</Button>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" type="submit" disabled={isLoading}>
                            {isLoading && <Spinner size="sm" className="me-2" />}
                            Save Changes
                        </Button>
                        <Button variant="secondary" onClick={() => setFinanceUpdateShow({ status: false, data: null })}>
                            Close
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
            {/* End of Modal Finance Update */}
        </section>
    )
}

export default PageFinancesBusiness